import React, { Component } from 'react';
import Typography from '@material-ui/core/Typography';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import Button from '@material-ui/core/Button';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Paper from '@material-ui/core/Paper';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import ShuffleIcon from '@material-ui/icons/Shuffle';
import { authHeader } from '../../components/auth-header';
import { withSnackbar } from 'material-ui-snackbar-provider'
import Switch from '@material-ui/core/Switch';

import { FormControlLabel, Radio, RadioGroup, FormLabel} from '@material-ui/core'

function TabContainer(props) {
    return (
        <Typography component="div" style={{ padding: 8 * 3 }}>
            {props.children}
        </Typography>
    );
}
const divStyle = {
    marginBottom: '20px',
    padding: ' 10px',
};

const errorDivStyle = {
    marginBottom: '20px',
    padding: ' 10px',
    color: 'red',
};

const minWidthFcStyle = {
    minWidth: 182,
    marginLeft: 8
};

const formStyle = {
    display: 'flex',
    padding: 10,
    maxWidth: 600,
    flexWrap: 'wrap',
};

const formControlStyle = {
    marginLeft: 8
};

class InseminationDetail extends Component {
    static displayName = InseminationDetail.name;

    constructor(props) {
        super(props);
        this.form = React.createRef();
        this.validate = this.validate.bind(this);
        this.handleInseminationBoolChange = this.handleInseminationBoolChange.bind(this);
        this.handleTabChange = this.handleTabChange.bind(this);

        var animalCode = props.match.params.id === "new" ? "" : props.match.params.animalCode;
        var inseminationId = props.match.params.id === "new" ? "" : props.match.params.id;
        var inseminationDate = props.match.params.id === "new" ? "" : props.match.params.date;
        var insemination = {};

        //find insemination in storage and pre-fill for edit
        if (localStorage.getItem('inseminations')) {
            var inseminations = JSON.parse(localStorage.getItem('inseminations'));
            if (Array.isArray(inseminations)) {
                if (inseminationId && inseminations.filter(insem => insem.id === inseminationId).length > 0) {
                    insemination = inseminations.filter(insem => insem.id === inseminationId)[0];
                    insemination.dateInsem = insemination.dateInsem.replace('T00:00:00', '');
                    if (insemination.calvingDate) {
                        insemination.calvingDate = insemination.calvingDate.replace('T00:00:00', '');
                    }
                } else if (animalCode && inseminationDate && inseminations.filter(insem => insem.animalCode === animalCode && insem.dateInsem.indexOf(inseminationDate) !== -1).length > 0) {
                    insemination = inseminations.filter(insem => insem.animalCode === animalCode && insem.dateInsem.indexOf(inseminationDate) !== -1)[0];
                    insemination.dateInsem = insemination.dateInsem.replace('T00:00:00', '');
                    if (insemination.calvingDate) {
                        insemination.calvingDate = insemination.calvingDate.replace('T00:00:00', '');
                    }
                }
            }
        }
        //find animal in storage and pre-fill info for insem. if no insem was found
        if (localStorage.getItem('animals') && Object.keys(insemination).length === 0) {
            var animals = JSON.parse(localStorage.getItem('animals'));
            var allAnimals = [];
            if (Array.isArray(animals)) {
                for (var i = 0; i < animals.length; i++) {
                    allAnimals = allAnimals.concat(animals[i].animals);
                }
            }
            if (allAnimals.filter(anim => anim.animalCode === animalCode).length > 0) {
                var animal = allAnimals.filter(anim => anim.animalCode === animalCode)[0];
                insemination = this.getInseminationDataFromAnimal(animal);
            }
        }

        //if still no animal/insemination data found
        if (Object.keys(insemination).length === 0) {
            var today = new Date();
            insemination.dateInsem = today.getFullYear().toString() + "-" + ('0' + (today.getMonth() + 1)).slice(-2).toString() + "-" + ('0' + today.getDate()).slice(-2).toString();
        }

        insemination.sexSemeno = insemination.sexSemeno || "0";
        this.state = {
            enum_ctg: [{ id: "1", text: "Krava" }, { id: "3", text: "Jalovica" }],
            animal: animal,
            insemination: insemination,
            tabId: 0
        };


        this.save = this.save.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleInseminationChange = this.handleInseminationChange.bind(this);
    }

    getInseminationDataFromAnimal(animal) {
        var insemination = {};
        if (!animal.animalCode) {
            return insemination;
        }

        insemination.animalCode = animal.animalCode;
        insemination.kraj = animal.breedingCode[0];
        insemination.okres = animal.breedingCode[1] + animal.breedingCode[2];
        insemination.podnik = animal.breedingCode[3] + animal.breedingCode[4] + animal.breedingCode[5];
        insemination.chov = animal.breedingCode[6] + animal.breedingCode[7] + animal.breedingCode[8];
        insemination.cowYoung = "1";

        var today = new Date();
        insemination.dateInsem = today.getFullYear().toString() + "-" + ('0' + (today.getMonth() + 1)).slice(-2).toString() + "-" + ('0' + today.getDate()).slice(-2).toString();

        return insemination;
    }

    handleChange(event) {
        this.setState({ [event.target.name]: event.target.value });
    }

    handleInseminationChange(event) {
        var insemination = this.state.insemination;
        insemination[event.target.name] = event.target.value;

        this.setState({ insemination: insemination });
    }

    handleInseminationBoolChange(event) {
        var insemination = this.state.insemination;
        insemination[event.target.name] = !insemination[event.target.name];

        this.setState({ insemination: insemination });
    }

    handleReInseminationChange(event) {
        var insemination = this.state.insemination;
        if (!insemination.orderRein) {
            insemination.order = 99; 
        }
        insemination[event.target.name] = insemination[event.target.name] ? 0 : 1;

        this.setState({ insemination: insemination });
    }

    handleTabChange = (event, value) => {
        if (!this.validate()) {
            return;
        }
        this.setState({ tabId: value });
    };

    save() {
        if (!this.validate()) {
            return;
        }
        var comp = this;
        comp.state.insemination.Id = comp.state.insemination.Id ? comp.state.insemination.Id : comp.state.insemination.id ? comp.state.insemination.id : 0;
        comp.state.insemination.exam = 88;

        var requestUri = comp.state.insemination.Id ? "api/Insemination/PutInsemination" : "api/Insemination/PostInsemination";
        var method = comp.state.insemination.Id ? "put" : "post";
        fetch(requestUri, {
            headers: { 'Content-Type': 'application/json', 'Authorization': authHeader().Authorization },
            method: method,
            body: JSON.stringify(comp.state.insemination)
        })
            .then(response => response.json())
            .then(data => {
                data.Id = data.Id ? data.Id : data.id ? data.id : 0;
                comp.storeInsemination(data);
               
                comp.props.snackbar.showMessage("Inseminácia bola uložená.");

                comp.props.history.push("/insemination-list");
            }).catch(function (err) {
                comp.storeInsemination(comp.state.insemination);
                comp.props.snackbar.showMessage("Inseminácia bola uložená lokálne.");

                comp.props.history.push("/insemination-list");
            });

        return false;
    }

    storeInsemination(insemination) {

        var inseminations = JSON.parse(localStorage.getItem("inseminations") ? localStorage.getItem("inseminations") : "[]");
        if (inseminations == null) inseminations = [];
        // Check for new insemination, if has ID compare ID if not compare date and animalCode
        if (inseminations.filter(ins => insemination.Id || insemination.id ? ((ins.id ? ins.id : ins.Id) === insemination.Id) : (ins.animalCode === insemination.animalCode && ins.dateInsem === insemination.dateInsem)).length > 0) {
            inseminations = inseminations.filter(ins => insemination.Id ? ((ins.id ? ins.id : ins.Id) !== insemination.Id) : (ins.animalCode !== insemination.animalCode || ins.dateInsem !== insemination.dateInsem));
        }
        inseminations.push(insemination);
        localStorage.setItem("inseminations", JSON.stringify(inseminations));
    }

    vytvorit() {
        this.state.insemination.invalidFields.push("animalCodeOk");
        this.save();
    }

    prestajnit() {
        this.state.insemination.invalidFields.push("prestajnenieOk");
        this.save();
    }

    renderVytvorenie() {
        if (this.state.insemination.invalidFields && this.state.insemination.invalidFields.indexOf("animalCode") > - 1 && this.state.insemination.invalidFields.indexOf("animalCodeOk") === -1) {
            return (
                <Paper style={errorDivStyle}>
                    <ShuffleIcon style={{ verticalAlign: 'text-bottom' }} /> Zviera sa nenašlo v kontrole úžitkovosti. Povtdte prosím správnosť ušného čísla.
                                                <Button
                        style={{ marginLeft: 10 }}
                        onClick={() => { this.vytvorit(); }}
                        variant="contained"
                        color="secondary"
                    >Potvrdiť</Button>
                </Paper>
            );
        } else {
            return <div></div>
        }
    }

    renderPrestajnenie() {
        if (this.state.insemination.invalidFields && this.state.insemination.invalidFields.indexOf("prestajnenie") > - 1 && this.state.insemination.invalidFields.indexOf("prestajnenieOk") === -1) {
            return (
                <Paper style={errorDivStyle}>
                    <ShuffleIcon style={{ verticalAlign: 'text-bottom' }} /> Zviera sa nachádza v inom chove, prajete si ho prestajniť ?
                                                <Button
                        style={{marginLeft: 10}}
                        onClick={() => { this.prestajnit(); }}
                        variant="contained"
                        color="secondary"
                    >Prestajniť</Button>
                </Paper>
            );
        } else {
            return <div></div>
        }
    }

    validate() {
        return this.form.current.reportValidity();
    }

    render() {
        if (this.state.insemination)
            return (
                <div>
                    <AppBar position="static">
                        <Tabs value={this.state.tabId} name="tabId" onChange={this.handleTabChange}>
                            <Tab label="Základne informácie" />
                            <Tab label="Rozšírené" />
                        </Tabs>
                    </AppBar>
                    {this.renderVytvorenie()}
                    {this.renderPrestajnenie()}
                    <Paper style={divStyle}>
                        <form ref={this.form} style={formStyle}>
                            {this.state.tabId === 0 && <TabContainer>
                                <FormControl error={this.state.insemination.invalidFields && this.state.insemination.invalidFields.indexOf("kraj") > -1} style={formControlStyle} margin="normal" required >
                                    <InputLabel htmlFor="kraj">Kraj</InputLabel>
                                    <Input type="number" inputProps={{ pattern: "\\d{1}", max: 9 }} id="kraj" name="kraj" value={this.state.insemination.kraj} onChange={this.handleInseminationChange} />
                                </FormControl>
                                <FormControl error={this.state.insemination.invalidFields && this.state.insemination.invalidFields.indexOf("okres") > -1} style={formControlStyle} margin="normal" required >
                                    <InputLabel htmlFor="okres">Okres</InputLabel>
                                    <Input type="number" inputProps={{ pattern: "\\d{2}", max: 99 }} id="okres" name="okres" value={this.state.insemination.okres} onChange={this.handleInseminationChange} />
                                </FormControl>
                                <FormControl error={this.state.insemination.invalidFields && this.state.insemination.invalidFields.indexOf("podnik") > -1} style={formControlStyle} margin="normal" required >
                                    <InputLabel htmlFor="podnik">Podnik</InputLabel>
                                    <Input type="number" inputProps={{ pattern: "\\d{3}", max: 999 }} id="podnik" name="podnik" value={this.state.insemination.podnik} onChange={this.handleInseminationChange} />
                                </FormControl>
                                <FormControl error={this.state.insemination.invalidFields && this.state.insemination.invalidFields.indexOf("chov") > -1} style={formControlStyle} margin="normal" required >
                                    <InputLabel htmlFor="breeding">Chov</InputLabel>
                                    <Input type="number" inputProps={{ pattern: "\\d{3}", max: 999 }} id="chov" name="chov" value={this.state.insemination.chov} onChange={this.handleInseminationChange} />
                                </FormControl>
                                <FormControl error={this.state.insemination.invalidFields && this.state.insemination.invalidFields.indexOf("tech") > -1} style={formControlStyle} margin="normal" required>
                                    <InputLabel htmlFor="tech">Technik</InputLabel>
                                    <Input inputProps={{ maxLength: 6 }} type="number" id="tech" name="tech" value={this.state.insemination.tech} onChange={this.handleInseminationChange} />
                                </FormControl>
                                <FormControl error={this.state.insemination.invalidFields && this.state.insemination.invalidFields.indexOf("animalCode") > -1} style={formControlStyle} margin="normal" required >
                                    <InputLabel htmlFor="animalCode">Ušné číslo</InputLabel>
                                    <Input inputProps={{ pattern: ".{14}" }} id="animalCode" name="animalCode" value={this.state.insemination.animalCode} onChange={this.handleInseminationChange} />
                                </FormControl>
                                <FormControl error={this.state.insemination.invalidFields && this.state.insemination.invalidFields.indexOf("cowYoung") > -1} style={minWidthFcStyle} component="fieldset" variant="outlined">
                                    <FormLabel component="legend" >Kategória</FormLabel >
                                    <RadioGroup
                                        row
                                        aria-label="Enabled"
                                        name="cowYoung"
                                        value={this.state.insemination.cowYoung}
                                        onChange={this.handleInseminationChange.bind(this)}
                                    >
                                        <FormControlLabel value="1"control={<Radio />} label="Krava" />
                                        <FormControlLabel value="3" control={<Radio />} label="Jalovica" />
                                    </RadioGroup>
                                </FormControl>
                                <FormControl required error={this.state.insemination.invalidFields && this.state.insemination.invalidFields.indexOf("dateInsem") > -1} style={minWidthFcStyle} margin="normal">
                                    <TextField
                                        name="dateInsem"
                                        id="dateInsem"
                                        label="Dátum inseminácie"
                                        onChange={this.handleInseminationChange.bind(this)}
                                        type="date"
                                        value={this.state.insemination.dateInsem}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                </FormControl>
                                <FormControl disabled={this.state.insemination.orderRein === 1} error={this.state.insemination.invalidFields && this.state.insemination.invalidFields.indexOf("order") > -1} style={formControlStyle} margin="normal" required>
                                    <InputLabel htmlFor="order">Por. ins.</InputLabel>
                                    <Input id="order" required type="number" name="order" value={this.state.insemination.order} onChange={this.handleInseminationChange} />
                                </FormControl>
                                <FormControlLabel error={this.state.insemination.invalidFields && this.state.insemination.invalidFields.indexOf("orderRein") > -1} style={minWidthFcStyle} margin="normal"
                                    control={
                                        <Switch
                                            id="orderRein"
                                            name="orderRein"
                                            checked={this.state.insemination.orderRein}
                                            onChange={this.handleReInseminationChange.bind(this)}
                                            value="1"
                                            color="secondary"
                                        />
                                    }
                                    label="Reinseminácia"
                                />

                                <FormControl required error={this.state.insemination.invalidFields && this.state.insemination.invalidFields.indexOf("bLin") > -1} style={formControlStyle} margin="normal"  >
                                    <InputLabel htmlFor="bLin">Býk línia</InputLabel>
                                    <Input id="bLin" inputProps={{ maxLength: 3, pattern: "[A-Za-z]{3}" }} name="bLin" value={this.state.insemination.bLin} onChange={this.handleInseminationChange} />
                                </FormControl>
                                <FormControl required error={this.state.insemination.invalidFields && this.state.insemination.invalidFields.indexOf("bReg") > -1} style={formControlStyle} margin="normal"  >
                                    <InputLabel htmlFor="bReg">Býk reg.</InputLabel>
                                    <Input inputProps={{ max: 999 }} type="number" id="bReg" name="bReg" value={this.state.insemination.bReg} onChange={this.handleInseminationChange} />
                                </FormControl>
                                <br /> <br />
                                <Typography variant="h5" component="h3"> Dodávateľ </Typography>
                                <FormControl required error={this.state.insemination.invalidFields && this.state.insemination.invalidFields.indexOf("company") > -1} style={formControlStyle} margin="normal" >
                                    <InputLabel htmlFor="company">Spoločnosť</InputLabel>
                                    <Input inputProps={{ pattern: ".{2}", max: 99 }} type="number" id="company" name="company" value={this.state.insemination.company} onChange={this.handleInseminationChange} />
                                </FormControl>
                                <FormControl required error={this.state.insemination.invalidFields && this.state.insemination.invalidFields.indexOf("stredisko") > -1} style={formControlStyle} margin="normal" >
                                    <InputLabel htmlFor="stredisko">Stredisko</InputLabel>
                                    <Input inputProps={{ pattern: ".{3}", max: 999 }} type="number" id="stredisko" name="stredisko" value={this.state.insemination.stredisko} onChange={this.handleInseminationChange} />
                                </FormControl>
                            </TabContainer>}
                            {this.state.tabId === 1 && <TabContainer>
                                <FormControl hidden error={this.state.insemination.invalidFields && this.state.insemination.invalidFields.indexOf("exam") > -1} style={formControlStyle} margin="normal" >
                                    <InputLabel htmlFor="exam">Teľnosť</InputLabel>
                                    <Input id="exam" name="exam" readOnly value="88" onChange={this.handleInseminationChange} />
                                </FormControl>
                                <FormControl error={this.state.insemination.invalidFields && this.state.insemination.invalidFields.indexOf("technology") > -1} style={minWidthFcStyle} margin="normal">
                                    <InputLabel shrink htmlFor="technology">Technológia</InputLabel>
                                    <Select
                                        id="technology"
                                        name="technology"
                                        value={this.state.insemination.technology}
                                        onChange={this.handleInseminationChange}
                                        input={<Input name="technology" id="technology" />}
                                        autoWidth
                                    >
                                        <MenuItem value="00">Bežná inseminácia</MenuItem>
                                        <MenuItem value="01">Inseminácia darkyne</MenuItem>
                                        <MenuItem value="99">Embryo transfer</MenuItem>
                                    </Select>
                                </FormControl>
                                <FormControl disabled={this.state.insemination.technology && this.state.insemination.technology === '99'} error={this.state.insemination.invalidFields && this.state.insemination.invalidFields.indexOf("sexSemeno") > -1} style={minWidthFcStyle} margin="normal">
                                    <InputLabel shrink htmlFor="sexSemeno">Sexované semeno</InputLabel>
                                    <Select
                                        id="sexSemeno"
                                        name="sexSemeno"
                                        value={this.state.insemination.sexSemeno}
                                        onChange={this.handleInseminationChange}
                                        input={<Input name="sexSemeno" id="sexSemeno" />}
                                        autoWidth
                                    >
                                        <MenuItem value="0">Nesexované</MenuItem>
                                        <MenuItem value="1">Sexované</MenuItem>
                                        <MenuItem value="2">Bovatel</MenuItem>
                                    </Select>
                                </FormControl>
                                <Typography variant="h5" component="h3"> Otelenie </Typography>
                                <FormControl error={this.state.insemination.invalidFields && this.state.insemination.invalidFields.indexOf("calvingDate") > -1} style={minWidthFcStyle} margin="normal">
                                    <TextField
                                        name="calvingDate"
                                        id="calvingDate"
                                        label="Dátum otelenia"
                                        onChange={this.handleInseminationChange.bind(this)}
                                        type="date"
                                        value={this.state.insemination.calvingDate}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                </FormControl>
                                <FormControl error={this.state.insemination.invalidFields && this.state.insemination.invalidFields.indexOf("calvingSex") > -1} style={minWidthFcStyle} margin="normal">
                                    <InputLabel shrink htmlFor="calvingSex">Typ otelenia</InputLabel>
                                    <Select
                                        id="calvingSex"
                                        name="calvingSex"
                                        value={this.state.insemination.calvingSex}
                                        onChange={this.handleInseminationChange}
                                        input={<Input name="calvingSex" id="calvingSex" />}
                                        autoWidth
                                    >
                                        <MenuItem value="00">Neuvedené</MenuItem>
                                        <MenuItem value="01">Býček</MenuItem>
                                        <MenuItem value="02">Jalovička</MenuItem>
                                        <MenuItem value="11">Dvojčatá</MenuItem>
                                        <MenuItem value="16">Živonarodené, uhynulo</MenuItem>
                                        <MenuItem value="22">Dvojčatá-jalovičky</MenuItem>
                                        <MenuItem value="26">Živonarodené, uhynuli</MenuItem>
                                        <MenuItem value="31">Dvojčatá-rôzne pohl.-býč.</MenuItem>
                                        <MenuItem value="32">Dvojčatá-rôzne pohl.-jal.</MenuItem>
                                        <MenuItem value="41">Dvojčatá-Živý býč.-2 mŕtvy.</MenuItem>
                                        <MenuItem value="42">Dvojčatá-Živá jal.-2 mŕtvy.</MenuItem>
                                        <MenuItem value="51">Živý býček z trojčiat</MenuItem>
                                        <MenuItem value="52">Živá jalovička z trojčiat</MenuItem>
                                        <MenuItem value="61">Žiadne živonar. a 1 mŕtve</MenuItem>
                                        <MenuItem value="62">Žiadne živonar. a 2 mŕtve</MenuItem>
                                        <MenuItem value="63">Žiadne živonar. a 3 mŕtve</MenuItem>
                                        <MenuItem value="81">Býček po prenose ET</MenuItem>
                                        <MenuItem value="82">Jalovička po prenose ET</MenuItem>
                                        <MenuItem value="91">Býček z importu</MenuItem>
                                        <MenuItem value="92">Jalovička z importu</MenuItem>
                                    </Select>
                                </FormControl>
                                <br /> <br />
                                <Typography variant="h5" component="h3"> Embryo transfer </Typography>
                                <FormControl error={this.state.insemination.invalidFields && this.state.insemination.invalidFields.indexOf("donor") > -1} style={formControlStyle} margin="normal"  >
                                    <InputLabel htmlFor="donor">Donor</InputLabel>
                                    <Input disabled={(this.state.insemination.sexSemeno && this.state.insemination.sexSemeno !== "0") || (this.state.insemination.technology && this.state.insemination.technology !== '99')} inputProps={{ pattern: ".{14}" }} id="donor" name="donor" value={this.state.insemination.donor} onChange={this.handleInseminationChange} />
                                </FormControl>
                                <FormControl error={this.state.insemination.invalidFields && this.state.insemination.invalidFields.indexOf("tchl") > -1} style={minWidthFcStyle} component="fieldset" variant="outlined">
                                    <FormLabel component="legend" >Technológia ET</FormLabel >
                                    <RadioGroup
                                        row
                                        aria-label="Enabled"
                                        name="tchl"
                                        value={ this.state.insemination.tchl}
                                        onChange={this.handleInseminationChange.bind(this)}
                                    >
                                        <FormControlLabel value="0" disabled={(this.state.insemination.sexSemeno && this.state.insemination.sexSemeno !== "0") || (this.state.insemination.technology && this.state.insemination.technology !== '99')} control={<Radio />} label="0"  />
                                        <FormControlLabel value="1" disabled={(this.state.insemination.sexSemeno && this.state.insemination.sexSemeno !== "0") || (this.state.insemination.technology && this.state.insemination.technology !== '99')} control={<Radio />} label="1"  />
                                        <FormControlLabel value="2" disabled={(this.state.insemination.sexSemeno && this.state.insemination.sexSemeno !== "0") || (this.state.insemination.technology && this.state.insemination.technology !== '99')} control={<Radio />} label="2"  />
                                        <FormControlLabel value="3" disabled={(this.state.insemination.sexSemeno && this.state.insemination.sexSemeno !== "0") || (this.state.insemination.technology && this.state.insemination.technology !== '99')} control={<Radio />} label="3"  />
                                    </RadioGroup>
                                </FormControl>
                                <br /> <br />
                                <Typography variant="h5" component="h3"> Faktúra </Typography>
                                <FormControl error={this.state.insemination.invalidFields && this.state.insemination.invalidFields.indexOf("ukon") > -1} style={formControlStyle} margin="normal" >
                                    <InputLabel htmlFor="ukon">Úkon</InputLabel>
                                    <Input id="ukon" name="ukon" value={this.state.insemination.ukon} onChange={this.handleInseminationChange} />
                                </FormControl>
                                <FormControl error={this.state.insemination.invalidFields && this.state.insemination.invalidFields.indexOf("davka") > -1} style={formControlStyle} margin="normal" >
                                    <InputLabel htmlFor="davka">Dávka</InputLabel>
                                    <Input id="davka" name="davka" value={this.state.insemination.davka} onChange={this.handleInseminationChange} />
                                </FormControl>
                            </TabContainer>}
                        </form>
                        <div>
                            <Button
                                onClick={() => { this.save(); }}
                                variant="contained"
                                color="secondary"
                            >Ulož</Button>
                        </div>
                    </Paper >
                </div>
            );
    }
}
export default withSnackbar()(InseminationDetail)


// WEBPACK FOOTER //
// ./src/components/technik/InseminationDetail.jsx